import { createContext, useContext } from 'react';

export interface Context {
  suspended: boolean;
}

const defaultValue = { suspended: false };

export const SuspenseContext = createContext<Context | null>(null);

export const useSuspenseContext = (): Context => {
  const value = useContext(SuspenseContext);

  if (value === null) {
    return defaultValue;
  }

  return value;
};
